import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, Layout, Tag, Descriptions, Empty } from 'antd';
import { MailOutlined, GithubOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getApplicationStatus } from '../services/api';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const statusMap: Record<string, { color: string; text: string }> = {
  PENDING: { color: 'processing', text: '等待审核' },
  APPROVED: { color: 'success', text: '已通过' },
  REJECTED: { color: 'error', text: '已拒绝' },
  INVITED: { color: 'success', text: '已发送邀请' },
  FAILED: { color: 'error', text: '邀请失败' },
};

const ResultPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [searched, setSearched] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      const res = await getApplicationStatus(values.email);
      setResult(res.data);
      setSearched(true);
    } catch {
      setResult(null);
      setSearched(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px' }}>
        <Card style={{ width: 520, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <GithubOutlined style={{ fontSize: 48, color: '#24292e' }} />
            <Title level={3} style={{ marginTop: 16 }}>查询申请状态</Title>
            <Paragraph type="secondary">输入提交申请时使用的邮箱地址</Paragraph>
          </div>
          <Form onFinish={onFinish} layout="vertical" size="large">
            <Form.Item
              name="email"
              rules={[
                { required: true, message: '请输入邮箱地址' },
                { type: 'email', message: '请输入有效的邮箱地址' },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="请输入邮箱地址" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                查询
              </Button>
            </Form.Item>
          </Form>

          {searched && result && result.found && (
            <Descriptions bordered column={1} style={{ marginTop: 16 }}>
              <Descriptions.Item label="状态">
                <Tag color={statusMap[result.status]?.color}>
                  {statusMap[result.status]?.text || result.status}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="提交时间">
                {new Date(result.createdAt).toLocaleString('zh-CN')}
              </Descriptions.Item>
              {result.rejectReason && (
                <Descriptions.Item label="拒绝原因">
                  {result.rejectReason}
                </Descriptions.Item>
              )}
            </Descriptions>
          )}

          {searched && (!result || !result.found) && (
            <Empty description="未找到相关申请记录" style={{ marginTop: 16 }} />
          )}

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <Button type="link" onClick={() => navigate('/')}>
              返回申请页面
            </Button>
          </div>
        </Card>
      </Content>
    </Layout>
  );
};

export default ResultPage;
